import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { IConfigResponse } from '@common/services/config/data/config-response.interface';
import { WINDOW } from '@common/services/ui/window.service';
import { WebServiceEndpoints } from '@common/web-service-endpoints';
import { IAutoLogoutSettings } from '@common/services/config/data/auto-logout-settings.interface';
import { IVideoSettings } from '@common/services/config/data/video-settings.interface';
import { IAvailabilitySettings } from '@common/services/config/data/availability-settings.interface';
import { IAuthSettings } from '@common/services/config/data/auth-settings.interface';
import { INotificationSettings } from './data/notification-settings.interface';
import { IConnectionCheckerSettings } from './data/connection-checker-settings.interface';
import { ILogSettings } from './data/log-settings.interface';
import { IRouteSettings } from './data/route-settings.interface';
import { ILabelsSettings } from './data/labels-settings.interface';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  public autoLogoutSettings: IAutoLogoutSettings;
  public videoSettings: IVideoSettings;
  public availabilitySettings: IAvailabilitySettings;
  public authSettings: IAuthSettings;
  public notificationSettings: INotificationSettings;
  public connectionCheckerSettings: IConnectionCheckerSettings;
  public labelsSettings: ILabelsSettings;
  public logSettings: ILogSettings;
  public routeSettings: IRouteSettings;
  public featuresByType = new Set<string>();
  private _tenantId: string;

  constructor(private readonly http: HttpClient, @Inject(WINDOW) private readonly window: Window) {}

  async load(): Promise<IConfigResponse> {
    let headers = new HttpHeaders();
    headers = headers.append('x-tenant-id', this.tenantId);

    const response = await this.http
      .post<IConfigResponse>(WebServiceEndpoints.Settings.config, {}, { headers })
      .toPromise();

    this.autoLogoutSettings = response.ClientAppSettings.AutoLogout;
    this.videoSettings = response.ClientAppSettings.VideoSettings;
    this.availabilitySettings = response.ClientAppSettings.AvailabilitySettings;
    this.authSettings = response.ClientAppSettings.AuthSettings;
    this.connectionCheckerSettings = response.ClientAppSettings.ConnectionCheckerSettings;
    this.logSettings = response.ClientAppSettings.LogSettings;
    this.notificationSettings = response.ClientAppSettings.NotificationSettings;
    this.labelsSettings = response.ClientAppSettings.Labels;
    response.ClientAppSettings.Features.forEach(({ FeatureType, IsEnabled }) => {
      if (IsEnabled) {
        this.featuresByType.add(FeatureType.toLowerCase());
      }
    });
    this.routeSettings = response.ClientAppSettings.RouteSettings;

    return response;
  }

  public get tenantId(): string {
    if (!this._tenantId) {
      const AllAfterFirstDashInDeepestDomainRegexp = /(?<=-)([^.]+)/g;
      this._tenantId = this.window.location.hostname.match(AllAfterFirstDashInDeepestDomainRegexp)[0];
    }
    return this._tenantId;
  }
}
